import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_landing")({
  head: () => ({
    meta: [
      {
        title: "Norgespris for Fjernvarme",
      },
    ],
  }),
});
